import React from "react";
import { Button, Popover, PopoverHeader, PopoverBody } from "reactstrap";

export default class InfoWrapper extends React.Component {
  static id = 0;

  state = {
    id: 0,
  };

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      popoverOpen: false,
      id: ++InfoWrapper.id,
    };
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  }

  render() {
    const { children } = this.props;
    const { id } = this.state;
    return (
      <div className="d-inline">
        {/* <Button id="Popover1" onClick={this.toggle}>
                    Launch Popover
                </Button> */}
        <em
          id={`Popover${id}`}
          className="fas fa-info-circle"
          style={{ fontSize: "13px" }}
          onMouseEnter={this.toggle}
          onMouseLeave={this.toggle}
        ></em>
        <Popover
          className="bg-light rounded-lg"
          placement="top"
          isOpen={this.state.popoverOpen}
          target={`Popover${id}`}
          toggle={this.toggle}
        >
          {/* <PopoverHeader>Comissão</PopoverHeader> */}
          <PopoverBody className="">{children}</PopoverBody>
        </Popover>
      </div>
    );
  }
}
